export enum IBoosterCategory {
    Promotion = "promotion",
    OfferStats = "offer_stats",
    BigDataStats = "bigdata_stats"
}
export enum IBoosterCategory {
    Promotion = "promotion",
    OfferStats = "offer_stats",
    BigDataStats = "bigdata_stats"
}
